import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'app-text-append',
  templateUrl: './text-append.component.html',
  styleUrl: './text-append.component.scss',
  standalone: false
})
export class TextAppendComponent {
  text = input<string | null>(null);
  splitText = computed(() => {
    const SPACE = ' ';
    const splitText: string[] = this.text()?.trim().split(SPACE) ?? [];
    const lastWord = splitText.pop();
    return {firstPart: splitText.join(SPACE), lastWordPart: lastWord};
  });
}
